import { ReactElement } from "react";
import { UnreachableCaseError } from "client_legacy/ndaw/errors";
import { UserRequestNotificationDataViewModel, UserRequestNotificationKind } from "client/Api/Notifications/notifications";
import { UserRequestDetailsDialog } from "client/Features/Settings/UserRequests/UserRequestDetailsDialog";
import { UserRequestsResponseDetailsDialog } from "client/Features/Settings/UserRequests/UserRequestResponseDetailsDialog";

export type UserRequestActivityInvocationProps = {
	data: UserRequestNotificationDataViewModel;
	onDismiss: () => void;
};

export const UserRequestActivityInvocation = (props: UserRequestActivityInvocationProps): ReactElement | null => {
	const {
		data,
		onDismiss
	} = props;

	if (!data.requestId) {
		onDismiss();
		return null;
	}

	switch (data.kind)
	{
		case UserRequestNotificationKind.Requested:

			return (
				<UserRequestDetailsDialog
					id={data.requestId}
					onClose={onDismiss}
					onResponded={onDismiss}
				/>
			);
		case UserRequestNotificationKind.Responded:
			return (
				<UserRequestsResponseDetailsDialog
					id={data.requestId}
					onClose={onDismiss}
				/>
			);
		default:
			throw new UnreachableCaseError(data);
	}
};

UserRequestActivityInvocation.displayName = "UserRequestActivityInvocation";